import {
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  LineIcon,
  LineShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';
import styled from 'styled-components';

import { Box } from './Grid';

const ShareBox = styled(Box)`
  .share-button {
    margin-left: 0.5rem;
    &:focus {
      outline: none;
      outline-offset: none;
    }
  }
`;

const ShareButton = ({ shareUrl, title }) => (
  <ShareBox mt="md">
    <FacebookShareButton url={shareUrl} quote={title} id="gtm-fb" className="share-button">
      <FacebookIcon size={32} round />
    </FacebookShareButton>

    <FacebookMessengerShareButton
      url={shareUrl}
      appId={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}
      className="share-button"
      id="gtm-messenger"
    >
      <FacebookMessengerIcon size={32} round />
    </FacebookMessengerShareButton>

    <TwitterShareButton url={shareUrl} title={title} id="gtm-twitter" className="share-button">
      <TwitterIcon size={32} round />
    </TwitterShareButton>

    <TelegramShareButton url={shareUrl} title={title} id="gtm-telegram" className="share-button">
      <TelegramIcon size={32} round />
    </TelegramShareButton>

    <WhatsappShareButton
      url={shareUrl}
      title={title}
      separator=":: "
      className="share-button"
      id="gtm-whatsapp"
    >
      <WhatsappIcon size={32} round />
    </WhatsappShareButton>
    <LineShareButton url={shareUrl} id="gtm-line" title={title} className="share-button">
      <LineIcon size={32} round />
    </LineShareButton>
  </ShareBox>
);

export default ShareButton;
